"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomMenu = void 0;
var classroom_1 = require("./classroom");
var collection_1 = require("./collection");
var enums_1 = require("./enums");
var properties = ['id', 'sort_order', 'type', 'entity_id', 'title', 'cover_id', 'cover'];
/**
 * Меню пользователя
 * пример - запиненные учебные классы в https://app.clickup.com/t/jq7fem
 */
var CustomMenu = /** @class */function () {
  function CustomMenu(values) {
    if (values === void 0) {
      values = {};
    }
    var instance = this;
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
    if ('entity' in values) {
      switch (instance.type) {
        case enums_1.CustomMenuTypeEnum.classroom:
          instance.entity = new classroom_1.Classroom(values.entity);
          break;
        case enums_1.CustomMenuTypeEnum.collection:
          instance.entity = new collection_1.Collection(values.entity);
          break;
        default:
          console.error('Entity type "' + enums_1.CustomMenuTypeEnum[instance.type] + '" not supported');
      }
    }
  }
  return CustomMenu;
}();
exports.CustomMenu = CustomMenu;
